"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var react_native_1 = require("react-native");
var useAppState = function useAppState() {
  var _ref = (0, react_1.useState)(react_native_1.AppState.currentState),
    _ref2 = _slicedToArray(_ref, 2),
    appState = _ref2[0],
    setAppState = _ref2[1];
  (0, react_1.useEffect)(function () {
    var onChanged = function onChanged(state) {
      return void setAppState(state);
    };
    var subscription = react_native_1.AppState.addEventListener("change", onChanged);
    return function () {
      subscription.remove();
    };
  }, [setAppState]);
  return {
    appState: appState,
    active: appState === "active"
  };
};
exports.default = useAppState;